import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFence = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.82933 4.01477C5.30862 3.93175 5.77814 4.20566 5.94174 4.66376L9 13.2269V5.00009C9 4.44781 9.44772 4.00009 10 4.00009C10.5523 4.00009 11 4.44781 11 5.00009V19.0001C11 19.4865 10.65 19.9024 10.1707 19.9854C9.69138 20.0684 9.22186 19.7945 9.05826 19.3364L6 10.7733V19.0001C6 19.5524 5.55228 20.0001 5 20.0001C4.44772 20.0001 4 19.5524 4 19.0001V5.00009C4 4.51366 4.35003 4.09779 4.82933 4.01477ZM13.8293 4.01477C14.3086 3.93175 14.7781 4.20566 14.9417 4.66376L18 13.2269V5.00009C18 4.44781 18.4477 4.00009 19 4.00009C19.5523 4.00009 20 4.44781 20 5.00009V19.0001C20 19.4865 19.65 19.9024 19.1707 19.9854C18.6914 20.0684 18.2219 19.7945 18.0583 19.3364L15 10.7733V19.0001C15 19.5524 14.5523 20.0001 14 20.0001C13.4477 20.0001 13 19.5524 13 19.0001V5.00009C13 4.51366 13.35 4.09779 13.8293 4.01477Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 5.00009C3 4.44781 3.44772 4.00009 4 4.00009H20C20.5523 4.00009 21 4.44781 21 5.00009C21 5.55238 20.5523 6.00009 20 6.00009H4C3.44772 6.00009 3 5.55238 3 5.00009Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 19.0001C3 18.4478 3.44772 18.0001 4 18.0001H20C20.5523 18.0001 21 18.4478 21 19.0001C21 19.5524 20.5523 20.0001 20 20.0001H4C3.44772 20.0001 3 19.5524 3 19.0001Z",
			fill: "currentColor"
		})
	]
});
export default SvgFence;
